module.exports = __webpack_public_path__ + "static/img/epidemic-1.4e255e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-1.png
// module id = HoGM
// module chunks = 1